import Grid from "@mui/material/Grid"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import SectionCard from "../components/SectionCard"

const Field = ({ label, value }) => (
  <MDBox mb={1}>
    <MDTypography variant="caption" color="text">
      {label}
    </MDTypography>
    <MDTypography variant="body2" fontWeight="medium">
      {value ?? "—"}
    </MDTypography>
  </MDBox>
)

const DetailTab = ({ request }) => {
  if (!request) return null
  const header = request.header || request
  const lines = request.paymentLines || []
  return (
    <MDBox>
      <SectionCard title="Request Details" icon="description" mb={2}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}><Field label="PR Code" value={header.prCode} /></Grid>
          <Grid item xs={12} md={4}><Field label="Created" value={header.createdAt} /></Grid>
          <Grid item xs={12} md={4}><Field label="Region" value={header.region} /></Grid>
          <Grid item xs={12} md={4}><Field label="Requester Region" value={header.requesterRegion} /></Grid>
          <Grid item xs={12} md={4}><Field label="Department" value={header.departmentName} /></Grid>
          <Grid item xs={12} md={4}><Field label="Category" value={header.categoryName} /></Grid>
          <Grid item xs={12} md={4}><Field label="Payment Method" value={header.paymentMethod} /></Grid>
          <Grid item xs={12} md={4}><Field label="Urgency" value={header.urgency} /></Grid>
          <Grid item xs={12} md={4}><Field label="Advance Amount" value={header.advanceAmount} /></Grid>
          <Grid item xs={12} md={4}><Field label="PO Code" value={header.poCode} /></Grid>
          <Grid item xs={12} md={4}><Field label="Total Amount" value={header.totalAmount?.toLocaleString?.()} /></Grid>
          <Grid item xs={12}><Field label="Reason" value={header.reason} /></Grid>
          <Grid item xs={12}><Field label="Allocation Info" value={header.allocationInfo} /></Grid>
          {header.amountDifferencesExplanation && (
            <Grid item xs={12}>
              <Field
                label="Amount differences explanation"
                value={header.amountDifferencesExplanation}
              />
            </Grid>
          )}
        </Grid>
      </SectionCard>

      <SectionCard title={`Payment Lines (${lines.length})`} icon="payments" mb={0}>
        {lines.map((l, i) => (
          <MDBox
            key={i}
            p={2}
            mb={1}
            bgColor="grey-100"
            borderRadius="lg"
          >
            <Grid container spacing={2}>
              <Grid item xs={12} md={3}><Field label="Supplier" value={l.supplierName} /></Grid>
              <Grid item xs={12} md={3}><Field label="Amount" value={Number(l.amount).toLocaleString()} /></Grid>
              <Grid item xs={12} md={3}><Field label="Payment type" value={l.paymentType} /></Grid>
              <Grid item xs={12} md={3}><Field label="Invoice #" value={l.invoiceNumber} /></Grid>
              {l.description && (
                <Grid item xs={12}><Field label="Description" value={l.description} /></Grid>
              )}
            </Grid>
          </MDBox>
        ))}
      </SectionCard>
    </MDBox>
  )
}

export default DetailTab
